import Projection from 'ol/proj/Projection'
import { getTopLeft } from 'ol/extent'
import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'

const code = 'EPSG:28992'

// THINGS FOR PROJECTION EPSG:28992 --> Dutch Projection, centered in Amersfoort
proj4.defs(
  code,
  '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs',
)
register(proj4)

const extent = [
  -285401.92,
  22598.08,
  595401.9199999999,
  903401.9199999999,
]

const projection = new Projection({
  code: code,
  extent,
})

const resolutions = [
  3440.640,
  1720.320,
  860.160,
  430.080,
  215.040,
  107.520,
  53.760,
  26.880,
  13.440,
  6.720,
  3.360,
  1.680,
  0.840,
  0.420,
  0.210,
  0.105,
]

const wmts = {
  matrixSet: code,
  origin: getTopLeft(extent),
  resolutions,
  matrixIds: Array.from(
    { length: 15 },
    (_, z) => `EPSG:28992:${z}`,
  ),
}

export default {
  code,
  projection,
  wmts,
}
